var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(
      _vm.$constants.situacoesMatriculaCondition[
        _vm.removerEspaco(_vm.matricula.situacao ? _vm.matricula.situacao : '')
      ]
    )?[_c('v-chip',{attrs:{"label":"","color":"error","small":""}},[_vm._v(_vm._s(_vm.matricula.situacao))])]:[(!_vm.mostrarResultado)?_c('span',[_vm._v("- - -")]):(_vm.mediaSemestral < _vm.notaMinima)?_c('v-chip',{attrs:{"label":"","color":"warning","small":""}},[_vm._v("RECUPERAÇÃO")]):_c('v-chip',{attrs:{"label":"","color":"success","small":""}},[_vm._v("APROVADO")])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }